import Vue from 'vue'
import Vuex from 'vuex'
import Emails from './emails'
import Email from './email'
import Search from './search'
import RawData from './rawdata'
import Display from './display'
import ImportJobLogs from './importjoblogs'
import Deduplicate from './deduplicate'
import ProductData from './productdata'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Emails,
        Email,
        Search,
        RawData,
        Display,
        ImportJobLogs,
        Deduplicate,
        ProductData,
    }
})
